import React from "react";
import MainLayout from "../Layout/MainLayout";
// import Editprofile from "../pages/Main/EditProfile";
// import Changepassword from "../pages/Main/ChangePassword";
// import Profile from "../pages/Main/Profile";
import Dashboard from "../pages/Main/Dashboard";
// import Interests from "../component/Interest/Interest";
// import UserList from "../components/Design/User/User";
// import UserDetails from "../components/Design/User/UserDetails";
// import MatchesList from "../component/Matches/Matcheslist";
// import Terms from "../pages/Main/Terms";
// import Privacy from "../pages/Main/Privacypolicy";
// import LikeList from "../component/User's Like/Like";
// import FavoriteList from "../component/Favorite/Favoritelist";
// import PushNotification from "../components/Design/Notification/PushNotification";
// import About from "../pages/Main/About";
import ProtectedRoute from "../Protected Routes/ProtectedRoute";
import UserList from "../pages/Main/User";
import UserRequest from "../pages/Main/Requests";
import Profile from "../pages/Main/Profile";
import ChangePassword from "../pages/Main/ChangePassword";
import Editprofile from "../pages/Main/EditProfile";
import Payments from "../pages/Main/Payments";
import FAQSList from "../pages/Main/FAQS";
import Addfaqs from "../pages/Main/AddFAQS";
import Editfaqs from "../pages/Main/EditFAQS";
import RequestDetails from "../pages/Main/RequestDetails";
import CategoryList from "../pages/Main/Categorylist";
import UserDetails from "../pages/Main/UserDetails";
import Addcategory from "../pages/Main/Addcategory";
import SubcategoryList from "../pages/Main/Subcategorylist";
import Addsubcategory from "../pages/Main/Addsubcategory";
import EditCategory from "../pages/Main/Editcategory";
import Posts from "../pages/Main/Post";
import PostDetails from "../pages/Main/PostDetails";
import EditSubcategory from "../pages/Main/Editsubcategory";
import Report from "../pages/Main/Report";
import Customerservice from "../pages/Main/Customerservice";
import CustomerServiceDetails from "../pages/Main/CustomerServiceDetails";
import PushNotification from "../pages/Main/PushNotification";
import AnalyticsDashboard from "../pages/Main/Analytics";
import Behaviour from "../pages/Main/Behaviour";
import CancelPosts from "../pages/Main/Cancelpost";
import MaintenanceInfo from "../pages/Main/Maintenance";
// import Language from "../component/language";
// import ReportList from "../component/Report";
// import ReportDetails from "../component/Report/ReportDetails";
// import ContactList from "../component/Contact Us";
// import ContactDetails from "../component/Contact Us/ContactDetails";
// import FAQSList from "../components/Design/FAQS/FAQS";
// import Addfaqs from "../components/Design/FAQS/AddFAQS";
// import Editfaqs from "../components/Design/FAQS/EditFAQS";
// import Hobby from "../component/Hobby/Hobby";
// import Icebreaker from "../component/Icebreaker/Icebreaker";
// import Addicebreaker from "../component/Icebreaker/AddIcebreaker";
// import Editicebreaker from "../component/Icebreaker/EditIcebreaker";
// import Datamanagement from "../components/Design/Data/Datamanagement";
// import UserChat from "../components/Design/User/UserChat";
// import MatchList from "../component/Readytomeet";

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  element: <MainLayout />,
  children: [
    {
      path: "/Dashboard",
      element: <AnalyticsDashboard />,
    },
    {
      path: "/User_List",
      element: <UserList />,
    },
    {
      path: "/User_Details",
      element: <UserDetails />,
    },
    {
      path: "/Category_List",
      element: <CategoryList />,
    },
    {
      path: "/Add_Category",
      element: <Addcategory />,
    },
    {
      path: "/Edit_Category",
      element: <EditCategory />,
    },
    {
      path: "/Subcategory_List",
      element: <SubcategoryList />,
    },
    {
      path: "/Add_Subcategory",
      element: <Addsubcategory />,
    },
    {
      path: "/Edit_Subcategory",
      element: <EditSubcategory />,
    },
    {
      path: "/Posts",
      element: <Posts />,
    },
    {
      path: "/Post_Details",
      element: <PostDetails />,
    },
    {
      path: "/Reports",
      element: <Report />,
    },
    {
      path: "/Customer_Service",
      element: <Customerservice />,
    },
    {
      path: "/Customer_Service/:id",
      element: <CustomerServiceDetails />,
    },
    {
      path: "/Analysis_Requests_Details",
      element: <RequestDetails />,
    },
    {
      path: "/FAQS_List",
      element: <FAQSList />,
    },
    {
      path: "/Add_FAQS",
      element: <Addfaqs />,
    },
    {
      path: "/Edit_FAQS",
      element: <Editfaqs />,
    },
    {
      path: "/Profile",
      element: <Profile />,
    },
    {
      path: "/EditProfile",
      element: <Editprofile />,
    },
    {
      path: "/ChangePassword",
      element: <ChangePassword />,
    },
    {
      path: "/Push_Notification",
      element: <PushNotification />,
    },
    {
      path: "/Maintenance",
      element: <MaintenanceInfo/>,
    },
    {
      path: "/Behaviour",
      element: <Behaviour />,
    },
    {
      path: "/Cacelled_Post",
      element: <CancelPosts />,
    },
    // {
    //   path: "/About_Us",
    //   element: <About />,
    // },
    // {
    //   path: "/Privacy_Policy",
    //   element: <Privacy />,
    // },
    // {
    //   path: "/TermsofService",
    //   element: <Terms />,
    // },
  ],
};

const MainRoutesWithProtection = {
  element: <MainLayout />,
  children: MainRoutes.children.map((route) => ({
    ...route,
    element: <ProtectedRoute>{route.element}</ProtectedRoute>,
  })),
};

export default MainRoutes;
